import { Component, Inject, OnInit } from '@angular/core';
import { Country} from "../enums";
import { SharedDataService } from "../gather-services/shared-data.service";
import { EnvironmentToken } from "../../../util";
import { Environment } from "../../../typings";
import { JobPosting } from "../gather-typings";
import { Subscription } from "rxjs";
import { GatherStateService } from "../gather-services/gather-state.service";

const JOB_CENTER_PATH = '/myaquent?PROC=AWUIDrawAdvancedJobSearch';
const JAPAN_JOB_CENTER_URL = 'https://aquent.co.jp/find-work';

@Component({
    selector: 'app-job-closed',
    templateUrl: './job-closed.component.html',
    styleUrls: ['./job-closed.component.scss'],
    standalone: false
})
export class JobClosedComponent implements OnInit {

  private countryId: number;
  private jobPosting: JobPosting;
  private subscriptions = new Subscription();

  constructor(private sharedDataService: SharedDataService,
              private gatherStateService: GatherStateService,
              @Inject(EnvironmentToken) private environment: Environment) { }

  ngOnInit(): void {
    this.subscriptions.add(
      this.sharedDataService.jobPosting.subscribe(jobPosting => {
        this.jobPosting = jobPosting;
        this.countryId = this.jobPosting.countryId;
      })
    );
    this.gatherStateService.setTitle('gather.job-closed.sorry');
  }

  goToUrl(buttonType: string): void {
    switch (buttonType) {
      case 'job':
        if (this.countryId === Country.Japan) {
          window.location.href = JAPAN_JOB_CENTER_URL;
        } else {
          window.location.href = this.environment.matHost + JOB_CENTER_PATH;
        }
        break;
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
